import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Button,
  Grid,
  Typography,
  Container,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  TextField,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const FormRecoveryPassword = ({
  classes,
  labelRef,
  onEmail,
  labelWidth,
  username,
  code,
  password,
  isError,
  isSubmitDisabled,
  onChange,
  onNewPassword,
}) => (
  <Container component="main" maxWidth="xs">
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        New password
      </Typography>
      <Typography component="h1" variant="subtitle1">
        Check your email we sent you a code
      </Typography>
      <form className={classes.form} noValidate>
        <FormControl className={classes.formControl} variant="outlined" error={isError}>
          <InputLabel ref={labelRef} htmlFor="component-outlined">
            Email *
          </InputLabel>
          <OutlinedInput
            onBlur={onEmail}
            labelWidth={labelWidth}
            id="component-outlined"
            value={username}
            onChange={onChange('username')}
          />
          {isError && <FormHelperText id="component-error-text">Enter a valid email</FormHelperText>}
        </FormControl>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="code"
          label="Code"
          name="code"
          value={code}
          onChange={onChange('code')}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          value={password}
          onChange={onChange('password')}
        />
        <Button
          disabled={isSubmitDisabled}
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={onNewPassword}
        >
          Recovery Password
        </Button>
        <Grid container>
          <Grid item xs>
            <Link to="/login">Return to login</Link>
          </Grid>
        </Grid>
      </form>
    </div>
  </Container>
);

FormRecoveryPassword.propTypes = {
  labelWidth: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  labelRef: PropTypes.object.isRequired,
  onEmail: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onNewPassword: PropTypes.func.isRequired,
};

export default FormRecoveryPassword;
